export default {
    methods: {
        onInput: function (hue, cb) {
            this.color.hue = hue
            this.hexColor = this.hslToHex(this.color.hue, this.color.saturation, this.color.luminosity)

            if (cb) {
                return cb(this.hexColor)
            }
        },
        hslToHex(h, s, l) {
            l /= 100
            const a = s * Math.min(l, 1 - l) / 100
            const f = n => {
                const k = (n + h / 30) % 12
                const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)
                return Math.round(255 * color).toString(16).padStart(2, '0')   // convert to Hex and prefix "0" if needed
            }
            return `#${f(0)}${f(8)}${f(4)}`
        },
        colorToHex() {
            return this.hslToHex(this.color.hue, this.color.saturation, this.color.luminosity)
        },
        getColorIconStyle(hexColor, marginTop = '1.2rem') {
            return `width: 30px; height:30px; background-color:${hexColor}; float:left; margin-right: 0.4rem; margin-top: ${marginTop}`
        },
    },
    data: () => {
        return {
            hexColor: "#ffd500",
            color: {
                hue: 50,
                saturation: 100,
                luminosity: 50,
                alpha: 1
            }
        }
    }
}
